export const timezoneUTCAvailable = () => {
  const timezone = [];
  for (let i = -12; i <= 14; i++) {
    const timeZoneObj = { id: i, title: `UTC${i >= 0 ? '+' : ''}${i}` };
    timezone.push(timeZoneObj);
  }
  return timezone;
};
